  export const faqData = [
    {
      id: 1,
      question: "What services does QASHQ offer?",
      answer: "QASHQ provides comprehensive accounting & bookkeeping, financial record and reporting, tax & corporate compliance, web development, app development, and digital marketing services."
    },
    {
      id: 2,
      question: "How long has QASHQ been in business?",
      answer: "QASHQ Business & IT Consultants has been serving clients with professional and reliable business and IT solutions for several years, building strong partnerships and delivering consistent results."
    },
    {
      id: 3,
      question: "Do you offer customized solutions?",
      answer: "Yes, we understand that every business is unique. We tailor our services to meet your specific needs and business goals, ensuring maximum value and effectiveness."
    },
    {
      id: 4,
      question: "What is your support availability?",
      answer: "We provide 24/7 support to our clients. You can reach us via email at contact.qashq@gmail.com or WhatsApp at +92 347 9310319 for any urgent matters."
    },
    {
      id: 5,
      question: "Can you help with tax compliance?",
      answer: "Absolutely. Our tax and corporate compliance services ensure your business meets all regulatory requirements, stays compliant with laws, and optimizes tax obligations."
    },
    {
      id: 6,
      question: "Do you provide IT solutions for small businesses?",
      answer: "Yes, we serve businesses of all sizes. Our IT solutions including web development, app development, and digital marketing are scalable and designed to fit your business requirements."
    }
  ];